import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import { jobService } from 'core/services'
import { IJob, IAgentRank, ISkill, IWindow } from 'static/interfaces'
import { IBuildedTour } from 'utils/weeklyTypes'
import SvgIcon from 'components/atoms/SvgIcon'
import Job from './Job'

declare var window: IWindow

interface IProps {
  tour: IBuildedTour
  tourSkills: Array<{ id: number; name: string }>
  skills: ISkill[]
  // GlobalModalはWeeklyProviderツリー外で描画されるため、contextではなくpropsで受け取る
  refetchTour: (tourId: number) => void
}

// TourDrawerの募集が複数件ある場合に、全募集の確認・編集を行うモーダル
const JobsDetailModalBody: React.VFC<IProps> = ({ tour, tourSkills, skills, refetchTour }) => {
  // null = 読込中(空表示と区別する)
  const [jobs, setJobs] = React.useState<IJob[] | null>(null)
  const [specialRanks, setSpecialRanks] = React.useState<IAgentRank[]>([])

  const fetchJobs = React.useCallback(() => {
    jobService
      .getJobs({ tour_id: tour.id, is_deleted: false })
      .then(res => {
        setJobs(res.jobs)
        setSpecialRanks(res.agent_ranks)
      })
      .catch(err => {
        console.error(err)
      })
  }, [tour.id])

  React.useEffect(() => {
    fetchJobs()
  }, [fetchJobs])

  // モーダル内で保存・削除された場合、モーダル自身の一覧と背後のドロワー/週viewの両方を更新する
  const handleRefetchTour = React.useCallback(
    (tourId: number) => {
      fetchJobs()
      refetchTour(tourId)
    },
    [fetchJobs, refetchTour]
  )

  return (
    <Wrapper>
      <div className="custom-modal-header">
        <div>この予約の募集</div>
        <SvgIcon
          className="close-button"
          name="close"
          width={24}
          height={24}
          role="button"
          onClick={() => {
            window.globalModal.closeModal()
          }}
        />
      </div>
      <div className="custom-modal-body">
        {jobs?.length === 0 && <p className="empty">募集はありません</p>}
        {(jobs || []).map(job => (
          <Job
            key={job.id}
            tour={tour}
            job={job}
            tourSkills={tourSkills}
            specialRanks={specialRanks}
            skills={skills}
            setCreating={() => undefined}
            isCreating={false}
            refetchTour={handleRefetchTour}
          />
        ))}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-size: 13px;

  .custom-modal-header {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    border-bottom: 1px solid ${constants.COLORS.divider};
    padding: 0 24px;

    .close-button {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }

  .custom-modal-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px;
    max-height: calc(100dvh - 196px);
    overflow-y: auto;
    overflow-x: hidden;

    .empty {
      color: ${constants.COLORS.subText};
      text-align: center;
      padding: 40px 0;
      margin: 0;
    }
  }
`

export default JobsDetailModalBody
